export default {
  BASE_URL: process.env.REACT_APP_API_URL,
  AI__URL: 'https://ai-func.onrender.com/api/v1/generateTextContent',
  SEARCH_IMAGE_URL:
    'https://pixabay.com/api/?key=48782973-0d73a4f40278a2b3e484ee278&pretty=true&image_type=photo&q=',

  END_POINT: {
    login: 'admin/login',
    signup: 'admin/signup',
    verify: 'verify',
    logout: 'logout',
    dashboard: 'admin/dashboard',
    navigation: 'admin/navigation',
    updatemenus: 'admin/update-menus',
    adminprofile: 'admin/profile',
    registration: 'registration',
    appusers: 'admin/app-users/',
    adminusers: 'admin/users/',
    deliveryboys: 'admin/delivery-boys/',
    assignorder: 'admin/assign-order/',
    masterdata: 'master-data/',
    reportdata: 'report-data',
    reportusers: 'reports/users',
    notification: 'notification/',
    sendnotification: 'send-notification',
    notificationsend: 'notification/send',
    bankdetails: 'bank-details/',
    getpackages: 'getpackages',
    addpackages: 'addpackages',
    updatepackages: 'updatepackages/',
    deletepackages: 'deletepackages/',
    paymenthistory: 'payment-history',
    countries: 'countries',
    states: 'states/',
    cities: 'cities/',
    banner: 'banner',
    coupon: 'coupons',
    menus: 'menus',
    categories: 'categories/',
    subcategories: 'subcategories/',
    products: 'products', // products?categoryId=1&subcategoryId=2&page=1&limit=10
    shoppingcart: 'admin/shopping-cart',
    checkout: 'admin/checkout',
    allOrders: 'admin/orders/all',
    pendingOrders: 'admin/orders/pending',
    orderHistory: 'admin/orders/history',
    completedOrders: 'admin/orders/completed',
    cancelledOrders: 'admin/orders/cancelled',
    salesreports: 'admin/sales-reports',
    customerreports: 'admin/customer-reports',
    customerinvoice: 'admin/customer-invoice',
    sendwhatsapp: 'send-whatsapp',
    calling: 'calling',
  },
}
